import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { useStoreSelectSearch } from '@/hooks/useStoreSelectSearch';
import type { StoreResponse } from '@/types/store';
import { useSelectLabels } from '@/hooks/useSelectLabels';

export interface StoreSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onStoreChange?: (store: StoreResponse | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  name?: string;
}

export function StoreSelect({
  label = 'Store',
  value = '',
  onChange,
  onStoreChange,
  placeholder,
  disabled,
  className,
  required,
  error,
  name,
}: StoreSelectProps) {
  const selectLabels = useSelectLabels();
  const { options, loading, searching, onSearchQuery, getStore } = useStoreSelectSearch({ value });

  const handleChange = (next: string) => {
    onChange?.(next);
    onStoreChange?.(next ? getStore(next) ?? null : null);
  };

  return (
    <SearchableSelect
      label={label}
      name={name}
      required={required}
      error={error}
      value={value}
      onChange={handleChange}
      options={options}
      placeholder={placeholder ?? selectLabels.selectStore}
      disabled={disabled}
      loading={loading}
      searching={searching}
      className={className}
      searchPlaceholder={selectLabels.searchStores}
      emptyMessage={selectLabels.noStores}
      filterLocally={false}
      onSearchQuery={onSearchQuery}
    />
  );
}
